import React, { useState } from "react";
import styles from './index.module.scss'
import ExchangeContent from "./compoments/exchangeContent";
import ExchangeAmount from "./compoments/exchangeAmount";
import { useGetBalanceData } from "@/api/request";
import { useExchangeTransfer, useQueryExchangeRate } from "./hooks/useWalletExchange";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

const WalletExchange = () => {
  const { t } = useTranslation('walletExchange')

  // 定义兑换类型的枚举
  enum ExchangeType {
    FROM = 0, // 从中心钱包兑换
    TO = 1 // 从虚拟钱包兑换
  }

  // 获取可用余额
  const { data: balanceData, isLoading, mutate, isValidating } = useGetBalanceData();
  // 获取兑换汇率
  const { data: exchangeData } = useQueryExchangeRate()
  /**
   * 兑换  exchangeTrigger(兑换方向, 两位小数金额)
   * 兑换方向: 1=中心钱包到虚拟币钱包 2=虚拟币钱包到中心钱包
   */
  const { trigger: exchangeTrigger, isMutating} = useExchangeTransfer();

  // 当前兑换方向
  const [exchangeType, setExchangeType] = useState<ExchangeType>(ExchangeType.FROM);
  // 当前兑换金额状态
  const [exchangeAmount, setExchangeAmount] = useState(0);
  
  // 切换兑换方向按钮处理函数
  const handleSwitch = () => {
    setExchangeType(prev => (prev === ExchangeType.FROM ? ExchangeType.TO : ExchangeType.FROM));
    setExchangeAmount(0); // 切换时清空金额
  };

  // 点击“立即兑换”按钮的处理逻辑
  const handleExchange = async () => {
    const isFromCenter = exchangeType === ExchangeType.FROM;
    const fromBalance = isFromCenter ? balanceData?.centerWalletBalance : balanceData?.usdtWalletBalance;
    if (exchangeAmount <= 0) {
      Toast.show(t('invalidRedeemAmount'));
      return;
    }
    if (exchangeAmount > fromBalance) {
      Toast.show(t('insufficientBalance'));
      return;
    }
    try {
      await exchangeTrigger({
        transferType: exchangeType === ExchangeType.FROM ? 1 : 2,
        amount: exchangeAmount,
      });
      mutate(); // 刷新余额
      setExchangeAmount(0);
      Toast.show(t('redeemSuccess'));
    } catch (err: any) {
      ErrorMessageDialog(err.message);
    }
  };


  return (
    <div className={styles.walletExchange}>
      <div className={styles.title}>{t('redeem')}</div>

      {/* 兑换信息和切换按钮 */}
      <ExchangeContent
        exchangeType={exchangeType}
        balanceData={balanceData}
        onSwitch={handleSwitch}
      />
      {/* 兑换金额输入 和 提交 */}
      <ExchangeAmount 
        exchangeType={exchangeType}
        balanceData={balanceData}
        exchangeRateData={exchangeData?.data}
        exchangeAmount={exchangeAmount}
        onAmountChange={setExchangeAmount}
        onSubmit={handleExchange}
        isLoading={isMutating}
      />
    </div>
  )
}

export default WalletExchange